import { Loader2, Send } from "lucide-react";

import { cn } from "@/lib/utils";

const VARIANT = {
	wa: "border-whatsapp/50 bg-whatsapp text-whatsapp-foreground hover:bg-whatsapp/90 focus-visible:ring-ring",
	amber: "border-warning/40 bg-warning/10 text-warning hover:bg-warning/20 focus-visible:ring-ring",
};

export function SendButton({
	real,
	disabled,
	pending,
	label,
	onClick,
}: {
	real: boolean;
	disabled: boolean;
	pending: boolean;
	label: string;
	onClick: () => void;
}) {
	return (
		<button
			type="button"
			data-slot="send"
			data-mode={real ? "real" : "dry_run"}
			disabled={disabled}
			aria-busy={pending}
			onClick={(event) => {
				if (event.detail < 2) {
					onClick();
				}
			}}
			className={cn(
				"control-button min-h-11 border px-4 py-2 md:min-h-10",
				"focus-visible:outline-none focus-visible:ring-1",
				"disabled:cursor-not-allowed disabled:opacity-50",
				real ? VARIANT.wa : VARIANT.amber,
			)}
		>
			{pending && <Loader2 className="size-4 animate-spin" />}
			{!pending && <Send className="size-4" />}
			{label}
		</button>
	);
}
